import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-launch-project-box _bxsh--base",
  role: "region",
  "aria-labelledby": "launch-project-box-title",
  "data-qa": "LaunchProjectBox"
}
const _hoisted_2 = { class: "_mt-0 _mb-2 _tc--dark _z-2" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_themed_image, {
      src: "/content/images/static/homepage/rocket.svg",
      alt: "Launch campaign",
      width: "38",
      class: "gfu-launch-project-box__image"
    }),
    _createVNode(_component_base_heading, {
      id: "launch-project-box-title",
      tag: "h2",
      class: "gfu-hd gfu-hd--h3 _mr-4 _mb-h _z-2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.StartCampaignBoxHeader), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.Homepage.StartCampaignBoxDescription), 1 /* TEXT */),
    _createElementVNode("a", {
      href: $options.becomeACreatorUrl,
      class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--micro",
      "aria-label": "Start your campaign",
      "data-qa": "LaunchProjectButton"
    }, [
      _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.StartCampaignBoxActionLabel) + " ", 1 /* TEXT */),
      _createVNode(_component_base_icon, {
        name: "chevron-right",
        class: "_ml-1",
        "aria-hidden": "true"
      })
    ], 8 /* PROPS */, _hoisted_3)
  ]))
}